export default __webpack_public_path__ + "static/media/ISMO SYLLABUS_2026-27 CLASS 5.21f4cbad.pdf";